import { defineStore } from "pinia";

export const useGlobalStream = defineStore("globalStream", {
  state: () => {
    return {
      controller: new AbortController(),
    };
  },
  actions: {
    stopStream() {
      this.controller.abort();
      this.controller = new AbortController();
    },
  },
});
